document.addEventListener('DOMContentLoaded', () => {
    initProductConfirmation();
});

function initProductConfirmation() {
    const confirmButton = document.getElementById('cordy-required-btn');
    
    if (confirmButton) {
        confirmButton.addEventListener('click', handleConfirmation);
    }
    
    // textareaの値が変更されるたびにバリデーションを実行
    const form = document.getElementById('cordy-required-confirmation-form');
    if (form) {
        const textareas = form.querySelectorAll('textarea');
        textareas.forEach(textarea => {
            textarea.addEventListener('input', () => {
                validateFormInRealTime(form);
            });
        });
    }
}

function handleConfirmation(event) {
    const form = document.getElementById('cordy-required-confirmation-form');
    
    if (validateRequiredFields(form)) {
        // 必須項目が全て入力されている場合
        event.target.classList.add('hidden');
        
        const purchaseButton = document.querySelector('.btn-buy-product');
        if (purchaseButton) {
            purchaseButton.classList.remove('hidden');
            purchaseButton.click();
        }
    }
}

// リアルタイムでフォームの状態を監視
function validateFormInRealTime(form) {
    const requiredFields = form.querySelectorAll('textarea[data-required="true"]');
    let hasEmptyField = false;
    
    requiredFields.forEach(field => {
        if (!field.value.trim()) {
            hasEmptyField = true;
        }
    });
    
    // 必須項目が空欄になった場合は購入ボタンを隠し、確認ボタンを表示
    if (hasEmptyField) {
        const purchaseButton = document.querySelector('.btn-buy-product');
        const confirmButton = document.getElementById('cordy-required-btn');
        
        if (purchaseButton) {
            purchaseButton.classList.add('hidden');
        }
        if (confirmButton) {
            confirmButton.classList.remove('hidden');
        }
    }
}

function validateRequiredFields(form) {
    // エラーメッセージをクリア
    clearAllErrors(form);
    
    // 必須項目（data-required="true"）のtextareaを取得
    const requiredFields = form.querySelectorAll('textarea[data-required="true"]');
    let hasError = false;
    let firstEmptyField = null;
    
    requiredFields.forEach(field => {
        if (!field.value.trim()) {
            showFieldError(field);
            hasError = true;
            if (!firstEmptyField) {
                firstEmptyField = field;
            }
        }
    });
    
    if (firstEmptyField) {
        scrollToElement(firstEmptyField);
    }
    
    return !hasError;
}

function clearAllErrors(form) {
    const errorMessages = form.querySelectorAll('.field-error-message');
    errorMessages.forEach(msg => {
        msg.classList.remove('show');
    });
}

function showFieldError(field) {
    const errorMessage = field.nextElementSibling;
    if (errorMessage && errorMessage.classList.contains('field-error-message')) {
        errorMessage.classList.add('show');
    }
}

function scrollToElement(element) {
    const offset = 120;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}

document.querySelectorAll('.no-comma').forEach(el => {
    // 入力イベントでカンマを削除（ペーストも対応）
    el.addEventListener('input', function() {
        this.value = this.value.replace(/,/g, '');
    });

    // キー入力時にカンマを無効化（入力時点で防ぐ）
    el.addEventListener('keydown', function(e) {
        if (e.key === ',') {
            e.preventDefault();
        }
    });
});